<nz-page-header nzTitle="Upload Bank Deposits"></nz-page-header>


<nz-upload
	nzType="drag"
	[nzMultiple]="false"
	[nzCustomRequest]="customUpload"
	[nzShowUploadList]="false">
	<p class="ant-upload-drag-icon">
		<i nz-icon nzType="inbox" ></i>
	</p>
	<p class="ant-upload-text">Click or drag file to this area to upload</p>
</nz-upload>
<ngb-progressbar *ngIf="uploadProgress || uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />



<div class="row mt-3">
	<div class="col">
		<app-table
			[data]="data"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[loading]="loading"
			[disablePaging]="false"
			(onRowClick)="doView($event)"
			(onUpdateRequired)="doFetchUploads($event)">
			<ng-template #cellRef let-row="row">
				<td>{{row.refUploadedAt | date}}</td>
			</ng-template>
			<ng-template #refAgent let-row="row">
				<td>
					{{row.agent.username??''}}
				</td>
			</ng-template>
			<ng-template #refProcessStartedAt let-row="row">
				<td>{{row.processStartedAt | date}}</td>
			</ng-template>
			<ng-template #refProcessCompletedAt let-row="row">
				<td>{{row.processCompletedAt | date}}</td>
			</ng-template>
		</app-table>
	</div>
</div>
